import { makeAutoObservable } from 'mobx'

// stub
class historyStore {

  constructor() {
    makeAutoObservable(this);
  }

  history = []
  textHistory = []
  colorHistory = []
  groupHistory = []
  historyIndex = 0

  appendToHistory(pageArr) {
    // make a copy of pages and add it to history
    // max history count 100
    const pages = pageArr.map(p => {
      return {
        ...p,
        cropperOpen: false
      }
    })
    const copyPages = JSON.parse(JSON.stringify(pages))
    if (!this.history.length) {
      this.history = this.history.concat([copyPages])
      this.historyIndex = this.history.length - 1
    }
    if (this.historyIndex === this.history.length - 1) {
      this.history = this.history.concat([copyPages])
      this.historyIndex = this.history.length - 1
    } else {
      this.history = this.history.filter((_, i) => i <= this.historyIndex).concat([copyPages])
      this.historyIndex = this.history.length - 1
    }
    if (this.history.length > 99) {
      this.history = this.history.slice(1)
      this.historyIndex = this.history.length - 1
    }
  }

  getHistory() {
    return [...this.history];
  }

  undo() {
    if (this.historyIndex > 0){
      this.historyIndex = this.historyIndex - 1
      return JSON.parse(JSON.stringify(this.history[this.historyIndex]))
    }
  }

  redo() {
    if (this.historyIndex < this.history.length -1){
      this.historyIndex = this.historyIndex + 1
      return JSON.parse(JSON.stringify(this.history[this.historyIndex]))
    }
  }
}

export default new historyStore